import { CurrentPartner } from 'components/currentPartner'
import { TitleRow } from 'components/titleRow'
import { useLocationsAdmin } from 'hooks/admin/useLocations/useLocations'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import React from 'react'
import { useParams } from 'react-router-dom'

import { Container, ContainerWrapper } from './locations.style'
import { LocationsTable } from './table/locationsTable'

export const LocationsAdmin: React.FC = () => {
    const { partnerId } = useParams<{ partnerId?: string }>()
    const { linkToForm, tableConfig, handleSearch } = useLocationsAdmin()

    const { data } = useOrganizations()
    const partnerName = React.useMemo(() => data?.find((org) => org.org_id === partnerId)?.name, [data, partnerId])

    return (
        <Container>
            <ContainerWrapper>
                {partnerId && partnerName && <CurrentPartner partnerName={partnerName}></CurrentPartner>}
                <TitleRow
                    configData={tableConfig.titleRow}
                    onSearch={handleSearch}
                    linkTo={linkToForm}
                    linkLabel={tableConfig.titleRow.buttonLabel}
                />
                <LocationsTable partnerId={partnerId} />
            </ContainerWrapper>
        </Container>
    )
}
